import { chunk, difference } from 'lodash'
import firebase from 'firebase/app'
import 'firebase/firestore'
import types from './types'

export default {
  [types.actions.loadList]: (context, ids) => {
    ids = ids.filter(id => !context.state.products.some(p => p.key === id) && !context.state.missingProductIds.some(pid => pid === id))

    chunk(ids, 10).forEach(gids => {
      firebase.firestore().collection('products')
        .where(firebase.firestore.FieldPath.documentId(), 'in', gids)
        .get()
        .then(snapshot => {
          let existingIds = []
          snapshot.forEach(product => {
            existingIds.push(product.id)
            var data = product.data()
            data.key = product.id
            context.commit(types.mutations.add, data)
          })

          const missingIds = difference(gids, existingIds)
          missingIds.forEach(id => context.commit(types.mutations.addMissingProductId, id))
        })
    })
  },
  [types.actions.load]: (context, id) => {
    if (context.state.products.some(p => p.key === id) || context.state.missingProductIds.some(pid => pid === id)) return

    firebase.firestore().collection('products')
      .doc(id)
      .get()
      .then(product => {
        if (!product.exists) {
          context.commit(types.mutations.addMissingProductId, id)
          return
        }
        var data = product.data()
        data.key = product.id
        context.commit(types.mutations.add, data)
      })
  }
}
